/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_Music_NoteInputs */

const en_shortcut_keys_name_insert_music_note = /** @type {(inputs: Shortcut_Keys_Name_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert ♪`)
};

const fr_shortcut_keys_name_insert_music_note = /** @type {(inputs: Shortcut_Keys_Name_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer ♪`)
};

const de_shortcut_keys_name_insert_music_note = /** @type {(inputs: Shortcut_Keys_Name_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfügen ♪`)
};

const it_shortcut_keys_name_insert_music_note = /** @type {(inputs: Shortcut_Keys_Name_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci ♪`)
};

const ru_shortcut_keys_name_insert_music_note = /** @type {(inputs: Shortcut_Keys_Name_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить ♪`)
};

const es_shortcut_keys_name_insert_music_note = /** @type {(inputs: Shortcut_Keys_Name_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar ♪`)
};

const zh_cn2_shortcut_keys_name_insert_music_note = /** @type {(inputs: Shortcut_Keys_Name_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入♪`)
};

const ja_shortcut_keys_name_insert_music_note = /** @type {(inputs: Shortcut_Keys_Name_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挿入♪`)
};

const hi_shortcut_keys_name_insert_music_note = /** @type {(inputs: Shortcut_Keys_Name_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सम्मिलित करें ♪`)
};

const pt_pt2_shortcut_keys_name_insert_music_note = /** @type {(inputs: Shortcut_Keys_Name_Insert_Music_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir ♪`)
};

/**
* | output |
* | --- |
* | "Insert ♪" |
*
* @param {Shortcut_Keys_Name_Insert_Music_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_music_note = /** @type {((inputs?: Shortcut_Keys_Name_Insert_Music_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_Music_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_insert_music_note(inputs)
	if (locale === "de") return de_shortcut_keys_name_insert_music_note(inputs)
	if (locale === "it") return it_shortcut_keys_name_insert_music_note(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_insert_music_note(inputs)
	if (locale === "es") return es_shortcut_keys_name_insert_music_note(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_insert_music_note(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_insert_music_note(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_insert_music_note(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_insert_music_note(inputs)
	return en_shortcut_keys_name_insert_music_note(inputs)
});